import { createUseStyles } from 'react-jss'
import { styleFragments } from '#base/js/variables.style'

export const style = {
  modal: {
    maxWidth: 480,
    width: '100%'
  },
  modalOverlay: {
    // The idle timer modal should lie over everything
    zIndex: 9999
  },
  modalBody: {
    ...styleFragments.baseHeaderFont,
    display: 'flex',
    alignItems: 'center',
    '& p': {
      lineHeight: 1.5,
      fontSize: 18
    }
  },
  modalTitle: {
    textTransform: 'none'
  }
}

export const useStyles = createUseStyles(style)
